import { render } from "./HeaderModulos.vue?vue&type=template&id=4dae6010&scoped=true"
import script from "./HeaderModulos.vue?vue&type=script&lang=js"
export * from "./HeaderModulos.vue?vue&type=script&lang=js"

import "./HeaderModulos.vue?vue&type=style&index=0&id=4dae6010&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dae6010"]])

export default __exports__